module.exports = __webpack_public_path__ + "img/united.30533f76.png";